var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rounded-full px-3 py-1 font-semibold text-xs uppercase pointer-events-none",class:_vm.classes},[_vm._v(" "+_vm._s(_vm.statusText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }